var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"c-tooltip-show"}},[(_vm.show)?_c('c-popover',_vm._b({ref:"popover",class:['c-tooltip', { '-dark': _vm.dark }],on:{"mouseover":function($event){$event.stopPropagation();}}},'c-popover',_vm.$attrs,false),[_c('div',{staticClass:"card",style:(_vm.cardSytles)},[_vm._t("default")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }